export default __webpack_public_path__ + "img/align-left.8995b8f7.svg";